import {environment} from "../../environments/environment";
import {ComboPayloadEnum} from "./enums/ComboPayload.enum";
import {IdiomaEnum} from "./enums/Idioma.enum";
import {PreguntasTipoEnum, SingleSubtipoEnum, Subtipo} from "./enums/PreguntasTipo.enum";
import {Nilable} from "./utils/Nullable";
import {PreguntasUtils} from "./utils/Preguntas.utils";

const urlAPI = environment.production ?
    "https://api.livepa.nl/v2"
    :
    environment.staging ?
        "https://api.staging.livepa.nl/v2"
        :
        "http://localhost:8000/v2";

const urlBO = environment.production ?
    "https://bo.livepa.nl"
    :
    environment.staging ?
        "https://bo-staging.livepanel.co"
        :
        "http://localhost:4200";

const urlSimulador = "https://survey.livepanel.co";
const urlS3 = environment.production
    ? "https://livepanel-prod.s3.amazonaws.com"
    : "https://livepanel-staging.s3.amazonaws.com";

export class Constants {
    public static get apiURL(): string {
        return urlAPI;
    }

    public static get S3URL(): string {
        return urlS3;
    }

    public static get apiURLV1(): string {
        return urlAPI.replace("v2", "v1");
    }

    public static get urlSimulador(): string {
        return urlSimulador;
    }


    public static get boURL(): string {
        return urlBO;
    }

    public static get titulo(): string {
        return "LivePanel | BackOffice";
    }

    public static get coloresSchema(): string[] {
        return ["#e57373", "#9575cd", "#4fc3f7", "#81c784", "#fff176",
            "#ff8a65", "#90a4ae", "#7986cb", "#4dd0e1", "#aed581",
            "#ffd54f", "#a1887f", "#ba68c8", "#64b5f6", "#4db6ac", "#dce775",
            "#ffb74d", "#e0e0e0", "#7626cd"];
    }

    public static obtenerIdioma(tipo: string): Nilable<IdiomaEnum> {
        switch (tipo.trim().toLowerCase()) {
        case "inglés":
        case "en":
            return IdiomaEnum.INGLES;
        case "portugués":
        case "portugues":
        case "pt":
        case "br":
            return IdiomaEnum.PORTUGUES;
        case "español":
        case "es":
            return IdiomaEnum.ESPANOL;
        default:
            return null;
        }
    }

    public static obtenerTipoMetadato(tipo: string): Nilable<ComboPayloadEnum> {
        switch (tipo.trim().toLowerCase()) {
        case "texto":
            return ComboPayloadEnum.PHRASING;
        case "puntos extra":
            return ComboPayloadEnum.EXTRA_POINTS;
        default:
            return null;
        }
    }

    public static existeTipo(tipo: string): boolean {
        return this.obtenerTipo(tipo) != null || this.obtenerSubtipo(tipo) != null;
    }

    public static obtenerTipo(tipo: string): Nilable<PreguntasTipoEnum> {
        return PreguntasUtils.obtenerTipo(tipo);
    }

    public static obtenerSubtipo(tipo: string): Nilable<Subtipo> {
        switch (tipo.toLowerCase()) {
        case "singletext":
        case "textotoitem":
            return SingleSubtipoEnum.SINGLE_TEXT;
        default:
            return null;
        }
    }
}
